import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { IMAGES } from "../../data/product";
import { useBag } from "../../context/BagContext";
import { trackAddToCart } from "../../lib/metaPixel";

export const StickyBuyBar = ({ product }) => {
  const { addToBag, open } = useBag();
  const [pastShop, setPastShop] = useState(false);
  const price = product?.price ?? 29.99;
  const currency = product?.currency ?? "USD";
  const money = new Intl.NumberFormat("en-US", { style: "currency", currency }).format(price);

  useEffect(() => {
    const target = document.getElementById("shop");
    if (!target) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Visible only once the shopper has scrolled PAST the product section.
        setPastShop(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {pastShop && !open && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-[#FFFDF9]/95 backdrop-blur-xl border-t border-[rgba(58,42,37,0.1)]"
          data-testid="sticky-buy-bar"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-10 py-3 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <img
                src={IMAGES.packshot}
                alt="CELUSTA Leave-In Conditioner"
                className="hidden sm:block w-10 h-10 object-contain rounded-lg bg-[#EDE3D6] p-1"
              />
              <div className="min-w-0">
                <p className="text-sm font-medium text-[#2B1F1B] truncate">CELUSTA Leave-In Conditioner</p>
                <p className="font-mono-accent text-[10px] uppercase tracking-[0.15em] text-[#9A8D85]">200 ml — Leave-in spray</p>
              </div>
            </div>
            <button
              onClick={() => { addToBag(1); trackAddToCart(product, 1); }}
              className="shrink-0 flex items-center gap-2 px-6 sm:px-8 py-3 bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] rounded-full hover:bg-[#55423A] transition-colors duration-300"
              data-testid="sticky-buy-bar-button"
            >
              <ShoppingBag size={14} strokeWidth={1.5} />
              Add to Bag — {money}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
